import React, { FC } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { JobPhaseReceivableSheetInterface } from '@vatos-pas/common';

import { PermissionsProvider } from 'providers/permissionsProvider';
import { CAN_EDIT_RECEIVABLE } from 'providers/permissions';

import { useInvoiceSave } from '../hooks/useInvoiceRow';

type InvoiceSaveFieldProps = PublicFieldProps &
  InjectedFieldProps<JobPhaseReceivableSheetInterface>;

const useStyles = makeStyles({
  saveButton: {
    marginTop: 8,
  },
});

// Trailing empty-header column holding the row's single shared Save/Update
// button: it commits both PO Amount and Invoice # together from the shared
// draft (see useInvoiceSave). Kept in its own column so the history icon sits
// directly after the Invoice # input rather than after this button.
export const InvoiceSaveField: FC<InvoiceSaveFieldProps> = ({ record }) => {
  const classes = useStyles();
  const { hasPermission } = PermissionsProvider.useContainer();
  const canEdit = hasPermission(CAN_EDIT_RECEIVABLE);
  const { submitting, hasChanges, hasExistingValues, handleSave } =
    useInvoiceSave(record);

  if (!record || !canEdit) return null;

  return (
    <Button
      className={classes.saveButton}
      variant="contained"
      color="primary"
      size="small"
      disabled={!hasChanges || submitting}
      onClick={handleSave}
    >
      {hasExistingValues ? 'Update' : 'Save'}
    </Button>
  );
};

export default InvoiceSaveField;
